module.exports = __webpack_public_path__ + "static/media/coins.97dc8c40.svg";